//
// Stores the server-minted anonymous session JWT for "Ask The Sea", separately from
// authedUser.js's real-login storage, so it can never affect isLoggedIn/authedUser state.
// The token itself is opaque to the frontend — there's no correctness reason to ever clear it
// on login/logout, so it just sits dormant while logged in and naturally expires server-side
// after its own lifetime.
//

const ANON_TOKEN_KEY = "theSeaAnonToken";

export const loadAnonToken = () => localStorage.getItem(ANON_TOKEN_KEY);

export const saveAnonToken = (token) => {
  if (token) localStorage.setItem(ANON_TOKEN_KEY, token);
};
